import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import handHeartIcon from '../../../assets/corazon.svg';
import { acceptCAC } from '../../../services/mentoriaService';
import authContext from '../../../shared/src/contexts/authContext';
import Button from '../../atoms/button/button';
import GoBackButton from '../../atoms/go-back-button/goBackButton';
import MentoriaModal from '../modal/modal';
import './caminoCasa.scss';

const CaminoCasa = () => {
	const [showModal, setShowModal] = useState(false);
	const Context = useContext(authContext);
	const navigate = useNavigate();

	const handleContinue = () => {
		setShowModal(false);
		window.location.replace(process.env.REACT_APP_REDIRECT_URL + '/');
	}

	const handleClickYes = async () => {
		setShowModal(true);
		try {
			await acceptCAC().catch(error => console.error(error))
		} catch (error) {
			console.error(error);
		}
	}

	return (
		<div className="mentoria-cac">
			<GoBackButton onClick={() => navigate("/formulario-inicial/resultado")}/>
			<div className="mentoria-cac__header">
				<h2 className="mentoria-cac__title">¡Cumples con los requisitos para hacer parte de Camino a mi casa!</h2>
				<p className="mentoria-cac__subtitle">Camino a mi casa es un programa de acompañamiento que busca acercar a las familias para que logren cumplir su propósito de tener una vivienda propia.</p>
			</div>
			<div className="mentoria-cac__video">
				<iframe width={560} height={315} src="https://www.youtube.com/embed/lxBLnEwJEKo" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
			</div>
			<section className="mentoria-cac__menu">
				<div className="mentoria-cac__menu__info">
					<div className="mentoria-cac__menu__info__container">
						<h2 className="mentoria-cac__menu__info__title">¿Quieres hacer parte de Camino a mi casa?</h2>
						<div className="mentoria-cac__menu__info__buttons">
							<Button text="NO" className='mentoria-cac__menu__info__buttons__button' disabled={false} type="button" onClick={() => navigate('/formulario-inicial/resultado')} />
							<Button text="SÍ" className='mentoria-cac__menu__info__buttons__button' disabled={false} type="button" onClick={handleClickYes} />
						</div>
					</div>
				</div>
				<div className="mentoria-cac__menu__image">
					<img src="//images.ctfassets.net/gkhyeghj07ak/3PRQUUS2eBMDzjg5ht9AhK/dcb8c73c84d078f86accb5a52f0efc5d/Programaci__n.png" alt="" />
				</div>
			</section>
			<MentoriaModal open={showModal} handleClose={handleContinue}>
				<div className='mentoria-cac__modal-content'>
					<img src={handHeartIcon} alt="Imagén de bienvenida a camino a mi casa" />
					<h2 className='mentoria-cac__modal-content__title'>¡Bienvenido!</h2>
					<p className='mentoria-cac__modal-content__text'>Pronto te llegará una invitación, a tu correo electrónico, a una charla donde te contaremos más de este programa.</p>
					<Button text='Continuar' className='mentoria-cac__modal-content__button' type='button' disabled={false} onClick={handleContinue} gtmClass="secondary" />
				</div>
			</MentoriaModal>
		</div>
	)
}

export default CaminoCasa;